import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/styles';

const useSharedUsersAndAccountStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    centerXY: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
    },
    fadeIn: {
      animation: 'fadeIn',
      animationDuration: '0.35s',
      height: '100%',
      padding: '40px',
    },
    headerLayout: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(1.5),
      '&:not(:first-child)': {
        marginTop: theme.spacing(4),
      },
      '& *': {
        outline: 'none',
      },
      '& h3': {
        lineHeight: 1,
        marginTop: -1,
      },
    },
    button: {
      borderColor: theme.palette.primary.contrastText,
      color: theme.palette.primary.contrastText,
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      '&:hover, &:focus': {
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
      },
    },
    buttonDisabled: {
      '&&': {
        borderColor: theme.palette.coolGrey[600],
        color: theme.palette.coolGrey[600],
      },
    },
    groupAvatar: {
      background: 'rgba(0, 0, 0, 0.5)',
      border: 'none',
      color: theme.palette.primary.contrastText,
      width: 48,
      height: 48,
    },
    groupPanelSubheaderText: {
      color: theme.palette.coolGrey[50],
      fontSize: '1.5rem',
      fontWeight: 900,
    },
    groupPanelContentText: {
      color: theme.palette.coolGrey[50],
      fontSize: '1em',
      fontWeight: 900,
    },
    listActionIcon: {
      color: theme.palette.coolGrey[600],
      '&:hover, &:focus': {
        background: `rgb(0, 6, 42)`,
        color: theme.palette.coolGrey[200],
      },
      '&:last-child': {
        marginRight: -theme.spacing(1.5),
      },
    },
    usersAndAccess: {
      height: '100%',
      width: '100%',
      overflowY: 'scroll',
      '&::-webkit-scrollbar': {
        background: `rgba(8, 34, 76, .875)`,
        borderRadius: '0 4px 4px 0',
      },
      '&::-webkit-scrollbar-thumb': {
        background: `rgba(0, 6, 42, .875)`,
        borderRadius: '0 4px 4px 0',
      },
    },
    lazyLoadedList: {
      overflowY: 'scroll',
      '&::-webkit-scrollbar': {
        background: `rgba(8, 34, 76, .875)`,
        borderRadius: '0 4px 4px 0',
      },
      '&::-webkit-scrollbar-thumb': {
        background: `rgba(0, 6, 42, .875)`,
        borderRadius: '0 4px 4px 0',
      },
    },
    listItem: {
      paddingLeft: theme.spacing(10),
      paddingRight: theme.spacing(10),
    },
    primaryInvitation: {
      color: theme.palette.coolGrey[50],
      fontSize: 16,
      textTransform: 'none',
    },
    secondaryInvitation: {
      color: theme.palette.coolGrey[300],
      fontSize: 14,
    },
    centerContent: {
      margin: '0 auto',
      padding: '40px 0',
      height: '100%',
      width: '100%',
    },
  })
);

export default useSharedUsersAndAccountStyles;
